import React, { useEffect, useState } from "react";
import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
} from "@react-pdf/renderer";
import Logo from "../../../Styles/imagenes/Logo Maquinaria.jpg";
import { FormatMoney } from "../../../Helpers/FormatNumber";


const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        backgroundColor: "#ffffff",
    },
    titulo: {
        backgroundColor: "#477c2c",
        height: 57,
        marginTop: 61,
        textAlign: "center",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 60,
    },
    tituloTexto: {
        fontSize: 20,
        marginLeft: 40,
        fontFamily: "RobotoFamily",
        letterSpacing: .5,
    },
    imagenContainer: {
        position: "absolute",
        top: 10,
        left: 30,
    },
    logoImagen: {
        width: 150,
    },
    texto: {
        fontSize: 8,
    },
});

const PagareSuscripcionPDF = ({ folio, consultas, setConsultas }) => {

    const variable = {
        precio: 75000,
        precioLetra: 'SETENTA Y CINCO MIL',
    }
    const currentDate = new Date();

    const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;

    return (
        <Document>
            <Page size="A4" orientation="portrait" style={styles.page}>
                <View>
                    <View style={styles.titulo}>
                        <Text style={styles.tituloTexto}>PAGARE</Text>
                    </View>
                    <View style={styles.imagenContainer}>
                        <Image src={Logo} style={styles.logoImagen} />
                    </View>
                </View>

                <View style={{ fontSize: 10, marginLeft: 30, marginRight: 30 }}>
                    <Text style={{ marginTop: 20, marginBottom: 20 }}>
                        Por este PAGARE, por valor recibido, me(nos) obligo(amos) a pagar solidaria, mancomunada e incondicionalmente, a la orden de: MAQUINARIA DEL HUMAYA, S.A. DE C.V., en la dirección de sus oficinas en la ciudad de Navolato, Sinaloa, o en cualquier otra donde se me requiera el pago, según lo elija el tenedor de este pagaré, la cantidad principal de $ {FormatMoney(variable.precio)} ({variable.precioLetra} PESOS 00/100 M.N.) mediante las amortizaciones pactadas, por los montos y las fechas que a continuación se detallan:
                    </Text>
                </View>
                <View style={{ marginLeft: 30, marginRight: 30 }}>
                    <View
                        style={{
                            flexDirection: "row",
                            fontSize: 10,
                            backgroundColor: "#ccc",
                            fontFamily: "RobotoFamily",
                        }}
                    >
                        <View style={{ width: 85 }}>
                            <Text>AMORTIZACION </Text>
                        </View>
                        <View style={{ width: 85 }}>
                            <Text>PESOS</Text>
                        </View>
                        <View style={{ width: 85 }}>
                            <Text>VENCIMIENTO </Text>
                        </View>
                        <View style={{ width: 85 }}>
                            <Text>AMORTIZACION </Text>
                        </View>
                        <View style={{ width: 85 }}>
                            <Text>PRECIO </Text>
                        </View>
                        <View>
                            <Text style={{ width: 85 }}>VENCIMIENTO </Text>
                        </View>
                    </View>
                    <View>
                        <View>
                            <View
                                style={{
                                    flexDirection: "row",
                                    fontSize: 10,
                                    borderBottomWidth: 1,
                                    borderColor: "#afb69d",
                                    marginTop: 5,
                                }}
                            >
                                <Text style={{ width: 85 }}>1/01</Text>
                                <Text style={{ width: 85 }}>{FormatMoney(variable.precio)}</Text>
                                <Text style={{ width: 85 }}>01/10/2023</Text>
                                <Text style={{ width: 85 }}></Text>
                                <Text style={{ width: 85 }}></Text>
                                <Text style={{ width: 85 }}></Text>
                            </View>
                        </View>

                    </View>
                </View>
                <View style={{ fontSize: 10, marginLeft: 30, marginRight: 30 }}>
                    <Text style={{ marginTop: 20, marginBottom: 5 }}>
                        El importe que ampara este pagaré causará intereses ordinarios en forma mensual desde la fecha de suscripción hasta la fecha de su liquidación, calculados a razón de la tasa fija del 21.50  (veintiuno  punto cincuenta ) por ciento anual sobre saldos insolutos.
                    </Text>
                    <Text style={{ marginBottom: 5 }}>
                        Los intereses se calcularán dividiendo la tasa anual aplicable entre 360 (Trescientos sesenta) y multiplicando el resultado obtenido por el número de días efectivamente transcurridos durante el periodo en que se devenguen los intereses.
                    </Text>
                    <Text style={{ marginBottom: 5 }}>
                        Asimismo, si se dejare de cumplir con el pago de la amortización pactada o no fuere cubierto a su vencimiento, pagare (mos) al beneficiario intereses moratorios desde la fecha del vencimiento hasta su total liquidación, a razón de la tasa normal vigente de acuerdo a lo establecido en los párrafos que preceden, multiplicado por 2(dos ), sobre saldos insolutos del importe principal de este pagaré, sin perjuicio de que se sigan causando los intereses a que se hace alusión en los párrafos antes mencionados.
                    </Text>
                    <Text style={{ marginBottom: 5 }}>
                        Para todo lo relativo a la interpretación, ejecución y cumplimiento del presente pagaré, el otorgante se somete expresamente a la jurisdicción de los tribunales competentes de la ciudad de Culiacán, Sinaloa, renunciando expresamente a cualquier otro fuero que pudiese corresponderle por razón de su domicilio presente, futuro o por cualquier ubicación de sus bienes.
                    </Text>
                </View>
                <View style={{ marginLeft: 30, marginRight: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <View style={{ width: 533, fontSize: 10, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', marginTop: 30 }}>
                        <Text>NAVOLATO, SINALOA A 06 DE JUNIO DEL 2023</Text>
                    </View>
                    <View style={{ flexDirection: "row", marginBottom: 60, fontSize: 8, marginTop: 20 }}>
                        <View style={{ flexDirection: "row", gap: 60 }}>
                            <Text style={{ width: 163, textAlign: "center" }}>SUSCRIPTOR (ES) </Text>
                            <Text style={{ width: 163, textAlign: "center" }}>AVAL (ES)</Text>
                        </View>
                    </View>
                    <View style={{ flexDirection: "row", marginBottom: 2, fontSize: 8 }}>
                        <View style={{ flexDirection: "row", gap: 60 }}>
                            <Text
                                style={{
                                    width: 163,
                                    borderBottomWidth: 1,
                                    borderColor: "#000",
                                    textAlign: "center",
                                }}
                            >
                            </Text>
                            <Text
                                style={{
                                    width: 180,
                                    textAlign: "center",
                                    borderBottomWidth: 1,
                                    borderColor: "#000",
                                }}
                            >
                            </Text>
                        </View>
                    </View>
                    <View style={{ flexDirection: "row", marginBottom: 10, fontSize: 10, marginLeft: 30, marginRight: 30 }}>
                        <View style={{ flexDirection: "row", gap: 60 }}>
                            <View>
                                <Text style={{ width: 180, textAlign: "left", marginBottom: 5, fontFamily: 'RobotoFamily' }}>
                                    ERIKA MARBELLA SICAIROS SOTO
                                </Text>
                                <Text style={{ width: 180, textAlign: 'left' }}>
                                    CONOCIDO EMANCIPACION
                                    SIND. EMILIANO ZAPATA
                                    CULIACAN,SINALOA
                                </Text>
                            </View>
                            <Text style={{ width: 163, textAlign: 'left' }}>
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default PagareSuscripcionPDF;
